<section [hidden]="isLoading">
    <div class="center-page-parent">
        <div class="center-page-child">
            <div class="login-content">
                <div class="col-12 col-lg-4 login login-background-left login-remove-padding" id="branded-background">
                    <div class="center-middle login-center-middle">
                        <div class="center-page-padding">

                            <!-------------------------------------------- LOGO -------------------------------------------->
                            <div class="text-center adjust-margin-bottom-1x">
                                <div class="login-logo"></div>
                            </div>

                            <!-------------------------------------------- HEADING -------------------------------------------->
                            <div class="text-center adjust-margin-bottom-1x adjust-padding-top-1x">
                                <h1 class="page-title error-page-title ng-star-inserted">{{errorCode}}</h1>
                            </div>

                            <!-------------------------------------------- FORM - Fields -------------------------------------------->
                            <div class="text-center branded-background" *ngIf="errorDetails && errorDetails.message">
                                <h4>{{errorDetails.message}}</h4>
                            </div>

                            <!-------------------------------------------- FORM - Buttons -------------------------------------------->
                            <div class="center-middle adjust-margin-bottom-1x adjust-padding-top-1x">
                                <div class="row row-form">
                                    <div class="col-12 adjust-margin-bottom-1x adjust-padding-top-1x">
                                        <button id="btnGoHome" [routerLink]="" (click)="goHome()" class="btn btn-secondary-mini btn-margins btn-label btn-label-home"><span class="btn-icon btn-icon-home"></span></button>
                                    </div>
                                </div>
                            </div>

                            <div class="row login-cta adjust-padding-top-1x">
                                <div class="col-12 text-left" [ngClass]="{'col-sm-6': isLoggedIn}">
                                    <a id="btnOpenHelp" [routerLink]="" (click)="openHelp()"><i class="far fa-envelope fa-padding"></i>Help</a>
                                </div>

                                <div class="col-12 col-sm-6 text-right" *ngIf="isLoggedIn">
                                    <a id="btnLogOut" [routerLink]="" (click)="logOut()">Log out<i class="far fa-right-from-bracket fa-padding-left"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-0 col-lg-8 hide-xs-md-block loadpage loading-background-right-float loading-remove-padding">
                    <div class="login-background-right">
                        <div class="page-inner loading-page-inner-2">
                            <div class="loading-carousel loading-carousel-background loading-carousel-background-static" *ngIf="errorDetails && errorDetails.description" style="background-position: left center;" [ngStyle]="{'background-image': 'url(' + errorDetails.backgroundIMG + ')'}">
                                <h2 class="page-subtitle inner-html" [innerHTML]="errorDetails.description"></h2>
                            </div>
                        </div>

                        <app-login-footer [showLinks]="false"></app-login-footer>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
